import { useMemo } from 'react'
import { useForm } from 'react-hook-form'
import { handleOnKeyDown } from 'src/utils/Form'
import Modal from 'src/components/Modal'
import { useSelector } from 'src/utils/store'
import { actions } from '../../TransfersState'
import { useDispatch } from 'react-redux'
import * as S from './ModalTransferEmptyCage.styles'
import { toast } from 'react-toastify'

interface ModalChangeCageFCProps {
  show: boolean
  onClose: () => any
}

interface FormData {
  address: string
  newIdFc: number
}

const ModalTransferEmptyCage = ({
  show,
  onClose,
}: ModalChangeCageFCProps) => {
  const {
    cageAddressInfo,
  } = useSelector((state) => state.transfers)

  const {
    register, resetField, getValues, setError, clearErrors, formState: { errors },
  } = useForm<FormData>()

  const dispatch = useDispatch()

  const availableFcs = useMemo(() => cageAddressInfo?.availableFcs.map((fc) => ({
    id: fc.id,
    description: fc.name,
  })), [cageAddressInfo?.availableFcs])

  const getCageAddressInfo = () => {
    clearErrors('address')

    const address = getValues('address')

    if (!address) {
      setError('address', {
        message: 'Endereço não informado',
      })
      return
    }

    dispatch(actions.getCageAddressInfo(address))
  }

  const clearData = () => {
    resetField('address')
    resetField('newIdFc')
    dispatch(actions.setProperty({
      property: 'cageAddressInfo',
      value: undefined,
    }))
  }

  const handleOnCancel = () => {
    clearData()
    onClose()
  }

  const handleOnConfirm = () => {
    if (!cageAddressInfo) {
      return
    }

    clearErrors('newIdFc')

    const newIdFc = getValues('newIdFc')

    if (!newIdFc) {
      setError('newIdFc', {
        message: 'Novo FC não selecionado',
      })
      return
    }

    const onSuccess = () => {
      clearData()
      onClose()
      toast.success('Gaiola transferida com sucesso!')
    }

    dispatch(actions.changeCageFc({
      idLocation: cageAddressInfo.idLocation,
      idFc: newIdFc,
      onSuccess,
    }))
  }

  return (
    <Modal
      show={show}
      title='Transferir Gaiola Vazia'
      centered
      closeButtonAction={onClose}
      closedButton
      testId='transfer-empty-cage-modal-test-id'
      body={(
        <S.Container>
          <S.CustomTextField
            label='Bipe o endereço da gaiola'
            id='address'
            name='address'
            type='text'
            autoComplete='off'
            autoFocus
            inputProps={{
              ...register('address'),
              'data-testid': 'address-input-test-id',
            }}
            error={!!errors.address}
            helperText={errors.address?.message}
            fullWidth
            size='small'
            onKeyDown={(event: any) => handleOnKeyDown(event, '', getCageAddressInfo)}
          />
          <S.CustomTextField
            label='Gaiola bipada'
            id='currentCage'
            name='currentCage'
            type='text'
            autoComplete='off'
            InputLabelProps={{ shrink: true }}
            inputProps={{
              'data-testid': 'current-cage-input-test-id',
              readOnly: true,
            }}
            fullWidth
            size='small'
            value={cageAddressInfo?.address || ''}
          />
          <S.CustomTextField
            label='FC atual'
            id='currentFc'
            name='currentFc'
            type='text'
            autoComplete='off'
            InputLabelProps={{ shrink: true }}
            inputProps={{
              'data-testid': 'current-fc-input-test-id',
              readOnly: true,
            }}
            fullWidth
            size='small'
            value={cageAddressInfo?.currentFc?.name || ''}
          />
          <S.CustomSelect
            id='newIdFc'
            name='newIdFc'
            label='Selecione o novo FC'
            type='text'
            variant='outlined'
            autoComplete='off'
            inputProps={{
              ...register('newIdFc'),
            }}
            options={availableFcs || []}
            error={!!errors.newIdFc}
            helperText={errors.newIdFc?.message}
            optionNone={false}
            fullWidth
            maxHeight='600px'
            dataTestId='new-fc-select-test-id'
            disabled={availableFcs === undefined || availableFcs?.length === 0}
          />
          <S.ContainerButtons>
            <S.CustomButton
              title='Cancelar'
              type='button'
              onClick={handleOnCancel}
              bgColor='red'
              hoverColor='redHover'
              letterColor='white'
              testId='cancel-button-test-id'
            />
            <S.CustomButton
              title='Confirmar'
              type='button'
              onClick={handleOnConfirm}
              bgColor='blue'
              hoverColor='darkBlueHover'
              letterColor='white'
              testId='confirm-button-test-id'
              disabled={cageAddressInfo === undefined}
            />
          </S.ContainerButtons>
        </S.Container>
      )}
    />
  )
}

export default ModalTransferEmptyCage
